<template>
  <div class="factoring-contractList-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @refresh-change="queryTableData"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
      <template slot="menuRight" slot-scope="scope"> 
       <el-tooltip class="item" effect="dark" content="显隐"
             placement="top">
            <el-button icon="el-icon-s-operation"
              circle @click="operation" ></el-button>
          </el-tooltip>
          </template>
          
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="saveData(row)">保存</el-button>
          <!-- <el-button type="primary" @click="openFilter">
            <a-icon type="filter" /> 高级筛选
          </el-button> -->
        </template>
        <template slot="file" slot-scope="scope">
          <div class="upload-container">
            <!-- :fileDynamicId="scope.row.id" -->
            <!-- 转贷  合同管理  用印文件 -->
            <WordUpload
              :index="scope.row.$index"
              @showFileName="showFileNameList"
              baFileMenuId="1612644476692492289"
              :id="scope.row.projectId"
              :fileDynamicId="scope.row.projectId"
              :plain="false"
              :tip="false"
              :readonly="scope.row.managerUser !=userInfo.user_id"
              v-if="scope.row.fileList.length == 0"
            />
            <!--readonly  只能传X个 -->
            <div class="" v-if="scope.row.fileList.length > 0">
              <div class="file_wrapper">
                <a
                  class="file_button"
                  target="_blank"
                  :href="
                    isWord(scope.row.fileList[0].fileUrl)
                      ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                      scope.row.fileList[0].fileUrl
                      : scope.row.fileList[0].fileUrl
                  "
                  type="text"
                  size="small"
                >
                  {{ getFileLengthName(scope.row.fileList[0].fileName) }}
                </a>
                <i
                  v-if="scope.row.managerUser ==userInfo.user_id"
                  @click="delSealFile(scope.row.fileList[0].id,scope.row.$index, 'fileList')"
                  class="el-icon-circle-close del_icon"
                ></i> 
              </div>
            </div>
          </div>
        </template>
        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            v-if="permission.contract_add"
            @click.stop="handleAdd()"
            >新建合同
          </el-button>

          <el-button
            type="primary"
            size="small"
            icon="el-icon-document-copy"
            v-if="permission.contract_add"
            @click.stop="
              nextSelectType = true;
              dialogShow = true;
              selectionMyList = [];
              stopStatus = 0;
              queryMyTableData(0);
              loading = true;
            "
            >批量提交
          </el-button>

          <el-button
            type="danger"
            size="small"
            icon="el-icon-document-delete"
            v-if="permission.contract_audit"
            @click.stop="
              nextSelectTypeStop = true;
              dialogShowStop = true;
              selectionMyListStop = [];
              stopStatus = 1;
              queryMyTableData(2);
              loading = true;
            "
            >合同终止
          </el-button>

          <!-- <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            @click.stop="handleEdit()"
            >编辑
          </el-button> -->
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="permission.contract_delete"
            :disabled="disabled"
            @click.stop="handleDelete()"
            >删除
          </el-button>
          <el-button size="small" icon="el-icon-download" @click="exportShow"
            >导出数据
          </el-button>
        </template>

        <template slot="contractName" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">
            {{ row.contractName }}
          </div>
        </template>
      </avue-crud>
    </div>

    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="tableConfig"
              ref="formScreen"
              v-model="searchForm"
              @submit="filterSearch"
              @reset-change="searchResetScreen"
            >
              <template slot="expectUseDay">
                <div class="form_slot">
                  <el-input-number
                    v-model="searchForm.expectUseDayMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="searchForm.expectUseDayMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
              <template slot="quota">
                <div class="form_slot">
                  <el-input-number
                    v-model="searchForm.quotaMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="searchForm.quotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>

    <el-dialog
      title="新建合同" :visible.sync="buildVisible" width="40%">
      <div class="addForm">
        <avue-form
          ref="basicInfo"
          v-model="addFormData"
          :option="addFormConfig"
        >
          <template #name>
            <!-- 存在绑定ID时不可更改项目 -->
            <SelectInput
              :clearable="false"
              ref="projectName"
              bindLabel="projectName"
              bindKey="id"
              dataUrl="zd/project/getListDefault"
              methods="post"
              dataMethod="data"
              searchKey="search"
              :initParam="initParam"
              @handleChange="setProjectInfo"
            />
            <!-- 
              :bindId="
                addFormData.projectInfoId ? addFormData.projectInfoId : ''
              "
             -->
          </template>
        </avue-form>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="批量提交审批"
      :visible.sync="dialogShow"
      :width="nextSelectType ? '80%' : '50%'"
    >
      <p class="dialog-tip" v-if="nextSelectType">
        以下为可选合同，请选择并开始提交审批：
      </p>
      <div class="crud_my_table" v-if="nextSelectType">
        <avue-crud
          :table-loading="loading"
          :option="myTableConfig"
          :data="myTableData"
          :page.sync="pageMyTable"
          @selection-change="selectionMyChange"
        ></avue-crud>
      </div>

      <el-form
        ref="auditForm"
        :model="auditForm"
        label-width="150px"
        v-if="!nextSelectType"
      >
        <el-form-item label="" required prop="contractNameList">
          <el-input
            type="textarea"
            :rows="3"
            v-model="auditForm.contractNames"
            autosize
            disabled
          ></el-input>

          <template slot="label">
            <span
              >已选择
              <span class="contractNameNumber"
                >{{ auditForm.contractNameList.length }}个</span
              >
              客户</span
            >
          </template>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="3"
            v-model="auditForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn_my_table">
        <el-button plain size="small" @click.stop="dialogShow = false"
          >取消
        </el-button>

        <el-button
          type="primary"
          size="small"
          plain
          v-if="nextSelectType"
          @click.stop="nextMySelect"
          :disabled="selectionMyList.length == 0"
          >下一步
        </el-button>

        <el-button
          type="primary"
          size="small"
          v-if="!nextSelectType"
          @click.stop="submitAudit"
          >确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="合同终止"
      :visible.sync="dialogShowStop"
      :width="nextSelectTypeStop ? '80%' : '50%'"
    >
      <p class="dialog-tip" v-if="nextSelectTypeStop">
        以下为可选合同，请选择并开始提交审批:
      </p>
      <div class="crud_my_table" v-if="nextSelectTypeStop">
        <avue-crud
          :option="myTableConfig"
          :data="myTableData"
          :page.sync="pageMyTable"
          :table-loading="loading"
          @selection-change="selectionMyChange"
        ></avue-crud>
      </div>

      <el-form
        ref="auditFormStop"
        :model="auditFormStop"
        label-width="150px"
        v-if="!nextSelectTypeStop"
      >
        <el-form-item label="" required prop="contractNameList">
          <el-input
            type="textarea"
            :rows="3"
            v-model="auditFormStop.contractNames"
            autosize
            disabled
          ></el-input>

          <template slot="label">
            <span
              >已选择
              <span class="contractNameNumber"
                >{{ auditFormStop.contractNameList.length }}个</span
              >
              客户</span
            >
          </template>
        </el-form-item>
        <el-form-item
          label="附件"
          prop="files"
          required
          :rules="[
            {
              required: true,
              message: '请上传附件',
            },
          ]"
        >
          <div class="project-name">
            <div class="upload-container">
              <WordUpload
                @showFileName="showFileName"
                fileMenuName="转贷业务合同管理合同终止"
                :id="auditFormStop.fileId"
                :plain="true"
                :tip="true"
              />
              <!--readonly  只能传X个 -->
              <div class="">
                <template v-for="(item, index) in auditFormStop.files">
                  <div class="file_wrapper" :key="index">
                    <a
                      class="file_button"
                      target="_blank"
                      :href="
                        isWord(item.fileUrl)
                          ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                            item.fileUrl
                          : item.fileUrl
                      "
                      type="text"
                      size="small"
                    >
                      {{ item.fileName }}
                    </a>
                    <i
                      @click="downLoadFile(item.id)"
                      class="el-icon-download del_icon"
                    ></i>
                    <i
                      @click="delFile(item.id, index, 'file')"
                      class="el-icon-circle-close del_icon"
                    ></i>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="3"
            v-model="auditFormStop.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn_my_table">
        <el-button size="small" plain @click.stop="dialogShowStop = false"
          >取消
        </el-button>

        <el-button
          type="primary"
          size="small"
          plain
          v-if="nextSelectTypeStop"
          @click.stop="nextMySelect"
          :disabled="selectionMyListStop.length == 0"
          >下一步
        </el-button>

        <el-button
          type="primary"
          size="small"
          v-if="!nextSelectTypeStop"
          @click.stop="submitAuditStop"
          >确定
        </el-button>
      </div>
    </el-dialog>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />
    <Options ref="Options"
          :plainOptions="optionColumn"
          :pageDataId="this.$route.path"
          @returnData="returnData"
        /> 
    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
// import { mapGetters } from "vuex";
import { downLoadTemplate } from "@/router/downLoadTem";
import { tableConfig, myTableConfig } from "./config";
import * as api from "@/api/zd/contract";
import Options from "@/components/ShowHidden/showhidden";
import SelectPerson from "@/components/SelectPersonnel/person";
import CommonSelect from "@/components/commonSelect/commonSelect";
import SelectDepartment from "@/components/SelectDepartment/department";
import ExportData from "@/components/exportData/exportData";
import SelectInput from "@/components/commonSelect/selectInput";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import WordUpload from "@/components/wordUpload/wordUpload";
import * as dictionaries from "@/api/zd/dictionaries";
import { mapGetters } from "vuex";
import {debounce} from "@/util/util";
let that=null;
export default {
  name: "contractList",
  mixins: [workFlow, util],
  data() {
    return {
      processKey: "process_zd_contract",
      detailFormUrl: "/zd/contractmanage/contractDetailBatch",
      optionColumn: [],
      initParam: { isSubmit: 1, myself: 1, auditStatus: 2, isContract: 1 },
      buildVisible: false,
      addFormData: {},
      addFormConfig: {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "选择项目",
            prop: "name",
            formslot: true,
            disabled: false,
            span: 20,
          },
        ],
      },
      selectionList: [],
      checkUserList: [],
      checkdepartment: [],
      searchForm: {},
      // filterSearchForm: {},

      drawer: false,
      // filterConfig: filterConfig(this.selectDeptClick, this.selectPersonClick),
      tableConfig: tableConfig(this.selectPersonClick, this.getMoney),
      myTableConfig: myTableConfig(this.selectPersonClick, this.getMoney),
      sortOption: "",
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      pageMyTable: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 100,
      },
      disabled: true,
      myTableData: [],
      dialogShow: false,
      selectionMyList: [],
      nextSelectType: true,
      auditForm: {
        contractNameList: [],
        contractNames: "",
        remark: "",
      },
      dialogShowStop: false,
      selectionMyListStop: [],
      nextSelectTypeStop: true,
      auditFormStop: {
        contractNameList: [],
        contractNames: "",
        remark: "",
        files: [],
        fileId: "",
      },
      files: [],
      loading: false,
      stopStatus: 0, //0 批量审批   1: 合同终止
      fileList: [],
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    CommonSelect,
    ExportData,
    SelectInput,
    WordUpload,
    Options
  },
  computed: {
    ...mapGetters(["userInfo", "permission"]),
    getFileLengthName(){
      return function(name){
        let fileName=name.length>12?name.substr(0,8):name
        let ext = name.length>12?name.substring(name.lastIndexOf('.')):''
        return  `${fileName}${ext ? `${ext}` : ''}`
      }
    },
  },
  watch: {
    selectionList: {
      handler(data) {
        let list = data.filter((item) => {
          return (
            item.managerUser == this.userInfo.user_id && item.auditState == 0
          );
        });

        this.disabled = data.length == 0 || list.length != data.length;
      },
      deep: true,
    },
  },
  mounted() {
    that=this
    this.sortOption = this.tableConfig.column;
    // this.queryTableData();
  },
  beforeDestroy() {
    //组件销毁前，把定义的滞空
    that=null
  },
  methods: {
     //显隐
     operation() {
      this.$refs.Options.showmode();
    },

     //回调
     returnData(data) {
      this.tableConfig.column = data;
    },
    
    showFileNameList(data, index) {
      this.$set(
        this.tableData[index],
        "fileList",

        data
      );
    },
    //附件回填
    showFileName(data, index) {
      this.$refs.auditFormStop.clearValidate();
      this.auditFormStop["files"] = data;
      this.files = data;
    },
    
    submitAudit:debounce(()=>{
      that.submitAuditDebounce()
    }, 500),
    // },
    async submitAuditDebounce() {
      let that = this;
      // let id = await this.setNewId();
      let redirectInfo = {
        url: this.detailFormUrl,
        id: "",
      };
      let processDefinedId = await this.userQueryProcessDefinedId(
        "process_zd_contract"
      );
      let params = {
        detailFormUrl: JSON.stringify(redirectInfo),
        processId: processDefinedId,
        comment: "",
        attachmentList: [],
        processInstanceName: "",
        remark: this.auditForm.remark,
      };

      let processInsId = await this.startWorkFlowProcess(params);
      let data = {
        flowableId: processInsId,
        detailFormUrl: JSON.stringify({
          url: "/zd/contractmanage/contractDetailBatch",
          id: processInsId,
        }),
        fileMenuName: "合同管理",
        fileMenuUrlname: "转贷",
        ids: this.auditForm.contractNameList.map((item) => {
          return item.id;
        }),
      };
      api.batchAudit(data).then(
        (res) => {
          that.loading = false;
          that.$message({
            type: "success",
            message: "操作成功!",
          });
          that.dialogShow = false;
          this.$router.push({
            path: `/zd/contractmanage/contractDetailBatch/${processInsId}`,
          });
        },
        (error) => {
          that.loading = false;
        }
      );
    },
    async submitAuditStop() {
      let that = this;
      if (this.auditFormStop.files.length == 0) {
        this.$message.error("请先上传附件");
        return;
      }

      // let redirectInfo = {
      //   url: this.detailFormUrl,
      //   id: "",
      // };
      // let processDefinedId = await this.userQueryProcessDefinedId(
      //   "process_zd_contract_stop"
      // );
      // let params = {
      //   detailFormUrl: JSON.stringify(redirectInfo),
      //   processId: processDefinedId,
      //   comment: "",
      //   attachmentList: [],
      //   processInstanceName: "",
      //   stopRemark: this.auditFormStop.remark,
      //   fileId: this.auditFormStop.fileId,
      // };

      // let processInsId = await this.startWorkFlowProcess(params);
      let data = {
        stopFlowableId: this.auditFormStop.fileId,
        stopRemark: this.auditFormStop.remark,
        // detailFormUrl: JSON.stringify({
        //   url: this.detailFormUrl,
        //   id: processInsId,
        // }),
        // fileMenuName: "转贷业务合同管理合同终止",
        // fileMenuUrlname: "转贷业务合同管理合同",
        ids: this.auditFormStop.contractNameList.map((item) => {
          return item.id;
        }),
      };
      api.batchStopAudit(data).then(
        (res) => {
          that.loading = false;
          that.$message({
            type: "success",
            message: "操作成功!",
          });
          that.dialogShowStop = false;
          this.$message.success("合同终止成功");
          this.queryTableData();
          // this.$router.push({
          //   path: `/zd/contractmanage/contractDetailBatch/${processInsId}`,
          //   // query: {
          //   //   stopStatus: 1,
          //   // },
          // });
        },
        (error) => {
          that.loading = false;
        }
      );
    },
    //批量审批下一步
    async nextMySelect() {
      let status = "";
      if (this.stopStatus == 1) {
        status = "Stop";
        let id = await this.setNewId();
        this.auditFormStop.fileId = id;
      }
      this["auditForm" + status].contractNameList =
        this["selectionMyList" + status];
      let contractNameList = this["selectionMyList" + status].map((item) => {
        return item.contractName;
      });
      this["auditForm" + status].contractNames = contractNameList.join("\n");

      this["nextSelectType" + status] = false;
    },

    setProjectInfo(data) {
      if (data.id) {
        this.buildVisible = false;
        this.$refs.projectName.reset();
        // window.sessionStorage.setItem("buildProjectInfo", JSON.stringify(data));
        // 跳转到详情
        this.$router.push({
          path: "/zd/contractmanage/contractDetail/0",
          query: {
            projectId: data.id,
          },
        });
      }
    },

    goDetail(row) {
      this.$router.push({
        path: `/zd/contractmanage/contractDetail/${row.id}`,
      });
    },

    //列表选择
    selectionChange(list) {
      this.selectionList = list;
    },
    //批量审核 和合同终止
    selectionMyChange(list) {
      if (this.stopStatus == 1) {
        this.selectionMyListStop = list;
      } else {
        this.selectionMyList = list;
      }
    },

    cloudTages(data) {
      this.searchForm = data;
    },

    saveData(row) {
      this.$refs.cloudtage.save(row);
    },

    selectDeptClick() {
      this.$refs.selectdepartment.showModel();
    },

    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      // this.getVisitPeople();
      let people = val.map((item) => {
        return item.realName;
      });
      let ids = val.map((item) => {
        return item.id;
      });
      this.searchForm.managerUser = ids.join(",");
      this.searchForm.managerUserName = people.join(",");
    },

    // 部门 获取
    setDepartment(data = []) {
      this.checkdepartment = data;
      let titleList = data.map((item) => {
        return item.title || item.fullName;
      });
      let ids = data.map((item) => {
        return item.key;
      });

      this.searchForm.managerDeptName = titleList.join(",");
      this.searchForm.managerDeptId = ids.join(",");
    },

    filterSearch(str, done) {
      this.page.currentPage = 1;
      this.queryTableData();
      this.drawer = false;
      done();
    },

    searchResetScreen() {
      this.searchForm = {};
      this.page.currentPage = 1;
      this.queryTableData();
    },

    searchReset() {
      this.searchForm = {};
      this.checkUserList = [];
      this.page.currentPage = 1;
      this.queryTableData();
    },

    searchChange(str, done) {
      this.queryTableData();
      done();
    },

    sortChange(val) {
      this.searchForm.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";
      this.searchForm.orderName = val.prop;
      this.page.currentPage = 1;
      this.queryTableData();
    },

    async queryTableData() {
      let params = {
        firstNum: (this.page.currentPage - 1) * this.page.pageSize,
        num: this.page.pageSize,
        ...this.searchForm,
        dateMin: this.searchForm.expectPayDate1
          ? this.searchForm.expectPayDate1[0]
          : undefined,
        dateMax: this.searchForm.expectPayDate1
          ? this.searchForm.expectPayDate1[1]
          : undefined,
      };
      let res = await api.getListcontract(params);
      if (res.data.code == 200) {
        let tableData = res.data.data.list;

        tableData.map((item, index) => {
          item.fileList = [];
          // this.findFileByOtherId(
          //   item.id,
          //   "1612644476692492289",
          //   "fileList",
          //   true,
          //   index
          // );
        });
        this.tableData = tableData;
        let fileArray = res.data.data.list.map((item) => {
          return item.projectId;
        });

        this.getFileName(fileArray);

        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // 获取文件名称
    getFileName(fileArray) {
      let self = this;
      let params = {
        // dynamicId:"",
        fileOtherId: fileArray,
        baFileMenuId: "1612644476692492289",
      };
      dictionaries
        .findFileByOtherIds(params)
        .then((res) => {
          self.tableData.map((el) => {
            if (res["data"]["data"][el.projectId]) {
              el["fileList"] = res["data"]["data"][el.projectId];
            }
          });
        })
        .catch((res) => {
          this.loading = false;
        });
    },

    findFileByOtherId(id, baFileMenuId, name, isList, index) {
      dictionaries
        .findFileByOtherId({
          fileOtherId: id,
          baFileMenuId: baFileMenuId,
        })
        .then((res) => {
          // this.tableData[index].file = res.data.data;
          this.$set(
            this.tableData[index],
            "fileList",

            res.data.data
          );

          // this.form[name + "Id"] = res.data.data;
        })
        .catch((res) => {});
    },
    //批量审核列表
    async queryMyTableData(auditStatus) {
      let params = {
        auditStatus: auditStatus,
        managerUser: this.userInfo.user_id,
        isStopFlow: auditStatus == 2 ? 0 : undefined,
        isBatch: 1,
      };
      let res = await api.getListcontract(params);
      if (res.data.code == 200) {
        this.myTableData = res.data.data.list;
        this.pageMyTable.total = this.myTableData.length;
        this.loading = false;
      } else {
        this.loading = false;
        this.$message.error(res.data.msg);
      }
    },
    handleAdd() {
      this.buildVisible = true;
    },

    handleDelete() {
      let self = this;
      this.$confirm("确定删除选择的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.deleteData();
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id;
      });
      let res = await api.contractRemove({ ids: ids.join(",") });
      if (res.data.code == 200) {
        this.queryTableData();
        this.$message.success("删除成功");
        // 刷新列表
        this.queryTableData();
      }
    },

    exportShow() {
      this.$refs.exportData.showModel();
    },

    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
        auditStatus: 1,
        auditState: 1,
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      downLoadTemplate("/api/blade-/zd/contract/export", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

    openFilter() {
      // 回显界面的筛选选项
      // this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
    //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this.files.splice(index, 1);
          this.auditFormStop["files"].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    delSealFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this.tableData[index][name].splice(0, 1);

          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.factoring-contractList-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
.btn_my_table {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
}
// .crud_my_table {
//   height: 400px;
//   overflow-y: scroll;
// }
/deep/ .crud_my_table .avue-crud__menu {
  display: none;
}
.contractNameNumber {
  font-weight: 700;
  color: #409eff;
  font-size: 13px;
}
</style>
 <style lang="scss">
.factoring-contractList-container {
  .el-table__fixed,
  .el-table__fixed-right {
    height: calc(100% - 0px) !important;
  }
  .el-table__fixed-footer-wrapper {
    display: none !important;
  }
}
.del_icon {
  cursor: pointer;
}
</style>